import React from "react";
import Assess from "../components/Assessments/Assess";

function AssessmentPages() {
  return (
    <div>
      <Assess />
    </div>
  );
}

export default AssessmentPages;
